const SET_WS_CONNECTION_ERROR = "connection::ws::set-error";
const SET_WS_CONNECTION_STATUS = "connection::ws::set-status";
const SET_WS_DEVICE_STATUS = "connection::ws::set-device-status";

function setWsConnStatusAction(online) {
  return {
    type: SET_WS_CONNECTION_STATUS,
    payload: {
      wsException: null,
      wsOnline: online,
    },
  };
}

function setWsConnErrAction(wsException) {
  return {
    type: SET_WS_CONNECTION_ERROR,
    payload: {
      wsException,
    },
  };
}

function setWsDeviceStatusOnline(online) {
  return {
    type: SET_WS_DEVICE_STATUS,
    payload: {
      deviceStatusOnline: online,
    },
  };
}

export {
  SET_WS_CONNECTION_ERROR,
  SET_WS_CONNECTION_STATUS,
  SET_WS_DEVICE_STATUS,
  setWsConnErrAction,
  setWsConnStatusAction,
  setWsDeviceStatusOnline,
};
